module.exports = "/_next/static/images/fhss-desktop-e65610384865a19070243cec87ca4a32.svg";